import { Link } from 'react-router-dom'

import { SymbiosisButton } from '~/components/SymbiosisButton'
import { useVESISParams } from '~/hooks/useVESISParams'

import LogoIcon from './assets/logo.svg'

import styles from './NoActiveLock.pcss'
import React from 'react'
import {VesisDescription} from "~/pages/VESISPage/AboutLock/VesisDescription";

export function NoActiveLock() {
	const { config } = useVESISParams()

	return (
		<>
			<VesisDescription/>
			<div className={styles.container}>
				<div className={styles.content}>
					<div className={styles.text}>
						YOU HAVE NO ACTIVE LOCKS CREATE YOUR FIRST LOCK
					</div>
					<LogoIcon />
				</div>
				<SymbiosisButton as={Link} to={`/vesis/${config.slug}/create`}>
					Create Lock
				</SymbiosisButton>
			</div>
		</>
	)
}
